import api from './api';

export interface File {
  id: number;
  tenant_id: number;
  patient_id?: number;
  meeting_id?: number;
  uploaded_by_user_id: number;
  file_name: string;
  file_type: string;
  file_size: number;
  s3_key: string;
  description?: string;
  created_at: string;
  updated_at: string;
  uploaded_by_name?: string;
  patient_name?: string;
  meeting_title?: string;
}

export interface FileListResponse {
  items: File[];
  total: number;
}

export const fileService = {
  async uploadFile(
    file: globalThis.File,
    description?: string,
    patientId?: number,
    meetingId?: number
  ): Promise<File> {
    const formData = new FormData();
    formData.append('file', file);
    if (description) formData.append('description', description);
    if (patientId) formData.append('patient_id', patientId.toString());
    if (meetingId) formData.append('meeting_id', meetingId.toString());

    const response = await api.post<File>('/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getFiles(patientId?: number, meetingId?: number): Promise<FileListResponse> {
    const params: Record<string, number> = {};
    if (patientId) params.patient_id = patientId;
    if (meetingId) params.meeting_id = meetingId;

    const response = await api.get<FileListResponse>('/files/', { params });
    return response.data;
  },

  async getFile(fileId: number): Promise<File> {
    const response = await api.get<File>(`/files/${fileId}`);
    return response.data;
  },

  async deleteFile(fileId: number): Promise<void> {
    await api.delete(`/files/${fileId}`);
  },

  async downloadFile(fileId: number): Promise<void> {
    // Download file directly from backend
    const response = await api.get(`/files/${fileId}/download`, {
      responseType: 'blob',
    });

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    console.log('Content-Disposition header:', contentDisposition);
    console.log('All headers:', response.headers);

    let fileName = 'download';
    if (contentDisposition) {
      // Try RFC 5987 format first (filename*=UTF-8''...)
      const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
      console.log('RFC 5987 match:', rfc5987Match);
      if (rfc5987Match && rfc5987Match[1]) {
        fileName = decodeURIComponent(rfc5987Match[1]);
        console.log('Decoded filename:', fileName);
      } else {
        // Fallback to standard format (filename="...")
        const standardMatch = contentDisposition.match(/filename="?(.+)"?/);
        console.log('Standard match:', standardMatch);
        if (standardMatch && standardMatch[1]) {
          fileName = standardMatch[1];
        }
      }
    }

    console.log('Final filename:', fileName);

    // Create blob URL and trigger download
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
